import { Link } from 'react-router-dom';
import { apiClient } from '../../tjenester/apiClient';

function PropertyCard({ portfolioReturnUrl, property }) {
  const statusLabel = property.availability === 'opptatt' ? 'Opptatt' : 'Ledig';

  return (
    <Link
      className="hover-lift group flex flex-col overflow-hidden rounded-[1.75rem] border border-forest-700/10 bg-white no-underline shadow-soft transition hover:border-forest-700/25 hover:shadow-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-700 focus-visible:ring-offset-2"
      to={`/eiendom/${property.slug}?returnTo=${encodeURIComponent(portfolioReturnUrl)}`}
    >
      <div className="relative flex min-h-[230px] items-center justify-center overflow-hidden bg-[linear-gradient(145deg,rgba(202,188,157,0.65),rgba(111,141,123,0.45))] font-semibold text-forest-900">
        {property.imageUrl ? (
          <img
            alt={property.name}
            className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-110"
            loading="lazy"
            src={apiClient.resolveMediaUrl(property.imageUrl)}
          />
        ) : null}
        <div className="absolute inset-0 bg-gradient-to-t from-forest-950/35 to-transparent opacity-0 transition group-hover:opacity-100" />
        <span className="absolute left-4 top-4 z-10 rounded-full bg-cream-100/95 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.1em] text-forest-900 shadow-sm">
          {statusLabel}
        </span>
        {property.imageUrl ? null : (
          <span aria-hidden="true" className="z-10 flex h-20 w-20 items-center justify-center rounded-2xl bg-cream-100/75">
            <svg fill="none" height="56" viewBox="0 0 64 64" width="56" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 31.5L32 13L54 31.5" stroke="#48685b" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
              <path d="M16 29V51H48V29" stroke="#48685b" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
              <rect fill="#6f8d7b" height="12" rx="2" width="10" x="27" y="39" />
              <rect fill="#cfd8d3" height="8" rx="1.5" width="8" x="19" y="35" />
              <rect fill="#cfd8d3" height="8" rx="1.5" width="8" x="37" y="35" />
            </svg>
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col px-6 py-6">
        <p className="text-sm font-medium text-sand-600">{property.address}</p>
        <h3 className="mt-2 text-[1.4rem] font-bold text-forest-900">{property.name}</h3>
        <dl className="mt-5 grid gap-3 sm:grid-cols-2">
          <div className="min-w-0 rounded-2xl bg-cream-100 p-3.5">
            <dt className="mb-1.5 text-[0.72rem] font-semibold uppercase tracking-[0.1em] text-sand-600">Type</dt>
            <dd className="m-0 break-words font-semibold text-forest-900">{property.type}</dd>
          </div>
          <div className="min-w-0 rounded-2xl bg-cream-100 p-3.5">
            <dt className="mb-1.5 text-[0.72rem] font-semibold uppercase tracking-[0.1em] text-sand-600">Storrelse</dt>
            <dd className="m-0 break-words font-semibold text-forest-900">{property.size}</dd>
          </div>
          {property.availableFrom ? (
            <div className="min-w-0 rounded-2xl bg-cream-100 p-3.5">
              <dt className="mb-1.5 text-[0.72rem] font-semibold uppercase tracking-[0.1em] text-sand-600">Ledig fra</dt>
              <dd className="m-0 break-words font-semibold text-forest-900">{property.availableFrom}</dd>
            </div>
          ) : null}
        </dl>
        <p className="mt-5 text-[1.02rem] leading-[1.65] text-forest-500">{property.summary}</p>
        <span className="mt-auto inline-flex items-center gap-2 pt-5 font-bold text-forest-700">
          Se detaljside
          <span aria-hidden="true" className="transition group-hover:translate-x-1">→</span>
        </span>
      </div>
    </Link>
  );
}

export default PropertyCard;